export const primaryColor = '#4154FF';

export const black = '#000000';
export const white = '#FFFFFF';

export const gray100 = '#f2f2f2';
export const gray600 = '#6d6d6d';

export const blue600 = '#4154FF';
export const yacare = '#008161';
export const green600 = '#008161';
export const green100 = '#D6EBE6';
export const darkgreen = '#247B9F';

export const blue100 = '#DFE2FF';
export const gray_border = '#61616133';
export const yacare_border = '#18A34D33';